import { RootStore } from ".";
import { observable, action } from "mobx";
import { NotificationLevel } from "./NotificationStore";


export class OrdersNotificationStore {



    _rootStore: RootStore;
    _localStorage: Storage;
    _document: Document;

    // @observable kasses: KassaInfo[] = [];
    @observable uncancelledOrders: number[] = [];


    constructor(rootStore: RootStore, localStorage: Storage, document: Document) {
        this._rootStore = rootStore;
        this._localStorage = localStorage;
        this._document = document;

    }



    @action
    private confirmNotification = (item: number) => {
        this.uncancelledOrders = this.uncancelledOrders.filter(w => w != item);
        this._localStorage.setItem("uncancelledOrdersForNotification", JSON.stringify(this.uncancelledOrders));
    }

    @action
    InitNewOrdersNotifications = () => {
        const scheme = this._document.location.protocol === "https:" ? "wss" : "ws";
        const port = this._document.location.port ? (":" + this._document.location.port) : "";
        this.uncancelledOrders = JSON.parse(this._localStorage.getItem("uncancelledOrdersForNotification") || "[]") || [];
        if (this.uncancelledOrders.length > 0) {
            this.uncancelledOrders.forEach((item, i) => {
                setTimeout(() => {
                    this._rootStore.notificationStore.addNotification(`В Абтеке получен новый заказ № ${item}`, NotificationLevel.info, 0, () => {
                        this.confirmNotification(item);
                    });
                }, i * 3);

            })
        }

        const connectionUrl = scheme + "://" + this._document.location.hostname + port + "/ws/neworders";

        const socket = new WebSocket(connectionUrl);

        socket.onopen = function () {
            console.debug("Socket is opened");
        };
        socket.onmessage = (ev: MessageEvent) => {
            this.uncancelledOrders.push(ev.data);
            this._localStorage.setItem("uncancelledOrdersForNotification", JSON.stringify(this.uncancelledOrders));
            this._rootStore.notificationStore.addNotification(`В Абтеке получен новый заказ № ${ev.data}`, NotificationLevel.info, 0, () => {
                this.confirmNotification(ev.data);
            });
        };

    }

}